const common = {
  Loading: "Yükleniyor",
  signUp: "Kayıt Ol",
  login: "Giriş Yap",
  logout: "Çıkış Yap",
  email: "E-posta",
  emailFormatErrorTips: "E-posta biçimi yanlış",
  emailDifferentTips: "Lütfen her iki alana da aynı e-postayı girin.",
  emailRegisteredTips: "Bu E-posta kaydedildi, lütfen başka bir e-posta seçin.",
  password: "Şifre",
  passwordFormatErrorTips:
    "Şifre 8-50 karakter arasında olmalı ve aşağıdakiler arasından en az iki kategori içermelidir: sayı, harf veya özel karakter.",
  passwordDifferentTips: "Lütfen her iki alana da aynı şifreyi girin.",
  verificationCode: "Doğrulama kodu",
  verificationCodeErrorTips: "Doğrulama kodu yanlış",
  confirm: "Onayla",
  cancel: "İptal",
  submit: "Gönder",
  confirmEmail: "E-postayı Onayla",
  formEmptyErrorTips: "Burada boş olamaz.",
  country: "Ülke/Bölge",
  birthday: "Doğum günü",
  anonymous: "Anonim",
  name: "İsim",
  nameFormatErrorTips: "Kullanıcı adı 50 karakter uzunluğunda olmalı ve özel karakterler içermemelidir",
  okBtn: "Tamam",
  serverErrorTips: "Üzgünüz, bir şeyler ters gitti, lütfen daha sonra tekrar deneyin.",
  updateSuccessTips: "Başarıyla değiştirildi",
  authorizationExpiredErrorTips: "Yetkilendirme süresi doldu, lütfen tekrar giriş yapın.",
  requestFrequentlyErrorTips: "Kısa sürede çok fazla aynı istek yapıldı, lütfen daha sonra tekrar deneyin.",
  GetCode:'kodu al'
};

export default common;
